import classNames from 'classnames'
import React, { useRef, useState } from 'react'

import { useLanguage } from '../../contexts/LanguageContext'
import { useUser } from '../../contexts/User'
import DropdownMenu from './DropdownMenu'
import LogoSection from './LogoSection'
import MobileMenu from './MobileMenu'
import NavigationLink from './NavigationLink'
import UserMenu from './UserMenu'

interface Props {
  className?: string
}

const TopBar: React.FC<Props> = (props) => {
  const { language, toggleLanguage } = useLanguage()
  const { email, name, checkPermissions } = useUser()
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)
  const userIconRef = useRef<HTMLDivElement>(null)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
    if (isUserMenuOpen) setIsUserMenuOpen(false)
  }

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen)
    if (isMenuOpen) setIsMenuOpen(false)
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
  }

  const closeDropdown = () => {
    setIsUserMenuOpen(false)
  }

  return (
    <div
      className={classNames(
        'z-10 flex w-full justify-center shadow-md',
        props.className
      )}
    >
      <div className="flex h-14 w-full max-w-screen-xl items-center justify-between px-4">
        <LogoSection toggleMenu={toggleMenu} />
        <NavigationLink checkPermissions={checkPermissions} />
        <UserMenu
          name={name}
          email={email}
          toggleUserMenu={toggleUserMenu}
          userIconRef={userIconRef}
          closeMenu={closeMenu}
          language={language}
          toggleLanguage={toggleLanguage}
        />
      </div>
      <MobileMenu
        isMenuOpen={isMenuOpen}
        checkPermissions={checkPermissions}
        closeMenu={closeMenu}
      />
      <DropdownMenu
        isUserMenuOpen={isUserMenuOpen}
        userIconRef={userIconRef}
        name={name}
        email={email}
        closeDropdown={closeDropdown}
        toggleLanguage={toggleLanguage}
        language={language}
      />
    </div>
  )
}

export default TopBar
